import React, { Component } from 'react';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../../theme/MorsTheme';
import {RESPONSE, API_BASE_URL, PDF_REPORTS_URL} from '../../resources/constant';

export default class bizCardOnlineAccessReq extends Component {

  render() {
    var url = PDF_REPORTS_URL+'BIZ_FORMS.pdf';

    return (
      <div>
        <BodyHeaderDiv>
            <BodyHeaderText>BIZ Cards Online Access Request</BodyHeaderText>
        </BodyHeaderDiv>
      <ContentDiv>
          <embed src={url} width="100%px" height="500px" />
      </ContentDiv>
      </div>
    );
  }
}